import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  listingTimeslotTitle: {
    id: 'addons.listingTimeslotTitle',
    description: 'AddOn timeslot section title',
    defaultMessage: 'Applicable timeslots',
  },
  listingTimeslotSubtitle: {
    id: 'addons.listingTimeslotSubtitle',
    description: 'AddOn timeslot section title',
    defaultMessage: 'Select timeslots this add-on applies to.',
  },
  noEventsFound: {
    id: 'addons.noEventsFound',
    defaultMessage: 'No events selected.\n'
     + 'Please select at least one event to be able to apply your add-on to timeslots.',
  },
  eventTitle: {
    id: 'addons.eventName',
    defaultMessage: 'Event name',
  },
  eventAvailability: {
    id: 'addons.eventAvailability',
    defaultMessage: 'Availability',
  },
  addTimeslots: {
    id: 'addons.addTimeslots',
    description: 'Add timeslots',
    defaultMessage: 'Add timeslots',
  },
  specificTimeslots: {
    id: 'addons.specificTimeslots',
    description: 'Specific timeslots',
    defaultMessage: 'Specific timeslots',
  },
  noTimeslotSpecified: {
    id: 'addons.noTimeslotSpecified',
    description: 'No timeslots specified.',
    defaultMessage: 'No timeslots specified.',
  },
  timeslotWarning: {
    id: 'addons.timeslotWarning',
    description: 'Timeslot warning',
    defaultMessage: "Timeslots don't match selected ticket types.",
  },
  allTimeslots: {
    id: 'addons.allTimeslots',
    description: 'All timeslots',
    defaultMessage: 'All timeslots',
  },
  allDays: {
    id: 'addons.allDays',
    description: 'All days',
    defaultMessage: 'All days of the week',
  },
  mondayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.monday',
    defaultMessage: 'Monday',
  },
  tuesdayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.tuesday',
    defaultMessage: 'Tuesday',
  },
  wednesdayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.wednesday',
    defaultMessage: 'Wednesday',
  },
  thursdayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.thursday',
    defaultMessage: 'Thursday',
  },
  fridayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.friday',
    defaultMessage: 'Friday',
  },
  saturdayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.saturday',
    defaultMessage: 'Saturday',
  },
  sundayWeekday: {
    id: 'manage.timeslotCustomization.bulkEditTimeslots.customTimeslot.weekday.sunday',
    defaultMessage: 'Sunday',
  },
  editButton: {
    id: 'addons.edit',
    description: 'edit button',
    defaultMessage: 'Edit',
  },
  deleteButton: {
    id: 'addons.delete',
    description: 'delete button',
    defaultMessage: 'Delete',
  },
  timeslotWarningPast: {
    id: 'addons.timeslotWarningPast',
    description: 'Timeslot warning for past date',
    defaultMessage: 'All selected timeslots are in the past.',
  },
  newCheckoutInfo: {
    id: 'addons.newCheckoutInfo',
    defaultMessage:
      "Applicable timeslots selection is only supported for eligible events.\n" +
      "Events that don't support this feature will not appear here.",
  },
});
